import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const revertToDraft = async (id: number): Promise<void> => {
	await cmsClient.patch(`/announcements/${id}/`, { status: "draft" });
};

const useRevertToDraft = () => {
	const queryClient = useQueryClient();

	const onSuccess = (_data: void, id: number) => {
		toast.success(<CustomToast type="Success" message="Reverted to draft" />, {
			hideProgressBar: true
		});
		queryClient.invalidateQueries(["announcements"]);
		queryClient.invalidateQueries(["announcement", id]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(revertToDraft, { onError, onSuccess });
	return mutation;
};

export default useRevertToDraft;
